/**
 * Labstep
 *
 * @module screens/ExperimentWorkflow/Show/CenterDeleted
 * @desc ExperimentWorkflow Show Screen Center Deleted
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import { LayoutMainContentCenter } from 'labstep-web/components/Layout/MainContent/Center';
import { Card } from 'labstep-web/core/Card/Card';
import { Header } from 'labstep-web/core/Header';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { ICenterDeletedProps, IDeletedCardProps } from './types';

export const DeletedCard: React.FC<IDeletedCardProps> = ({
  entity,
}) => (
  <div>
    <p>{`This ${getHumanReadableEntityName(
      entity.entityName,
    )} is deleted.`}</p>
    <EntityActionDelete
      actionComponentProps={{
        type: 'button',
      }}
      entity={entity}
    />
  </div>
);

export const CenterDeleted: React.FC<ICenterDeletedProps> = ({
  entity,
  messageForDeleted,
}) => (
  <LayoutMainContentCenter>
    <Card>
      <Header isDataPublic={false} size="large">
        {entity.displayName}
      </Header>
      <DeletedCard entity={entity} />
      {messageForDeleted}
    </Card>
  </LayoutMainContentCenter>
);
